import CollectionCover from './cover/Cover';
import NewCollectionLayout from './NewCollectionLayout';
export { CollectionCover, NewCollectionLayout };